<ac-loading-overlay *ngIf="actionLoader$ | async"></ac-loading-overlay>
<div>
<ac-button  class="download-btn" (onClick)="downloadAll()" [label]="'ac.global.buttons.download-all' | translate" suffixIcon="vertical_align_bottom" ></ac-button>
</div>
